export default __webpack_public_path__ + "d8d1ed6b9ec0078cbf5dc808a4816cf1.jpg";